import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_NOSCRIPT_TITLE',
    defaultMessage: 'Xing braucht JavaScript',
  },
  paragraph: {
    id: 'LOGIN_NOSCRIPT_PARAGRAPH',
    defaultMessage:
      'Aktivieren Sie bitte JavaScript, denn nur so sehen Sie alle unsere Inhalte. Wie Sie das genau machen, lesen Sie auf:',
  },
  linkTarget: {
    id: 'LOGIN_NOSCRIPT_LINK_TARGET',
    defaultMessage: 'https://faq.xing.com/node/67945',
  },
  linkText: {
    id: 'LOGIN_NOSCRIPT_LINK_TEXT',
    defaultMessage: 'JavaScript aktivieren',
  },
});
